import React from 'react';
interface ProjectCardProps {
  title: string;
  category: string;
  description: string;
  image: string;
}
const ProjectCard: React.FC<ProjectCardProps> = ({
  title,
  category,
  description,
  image
}) => {
  return <div className="bg-white rounded-lg overflow-hidden shadow-lg" data-id="element-122">
      <div className="h-64 overflow-hidden" data-id="element-123">
        <img src={image} alt={title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" data-id="element-124" />
      </div>
      <div className="p-6" data-id="element-125">
        <span className="text-red-600 font-medium text-sm" data-id="element-126">{category}</span>
        <h3 className="text-xl font-bold mt-2 mb-3" data-id="element-127">{title}</h3>
        <p className="text-gray-600" data-id="element-128">{description}</p>
      </div>
    </div>;
};
export default ProjectCard;